import CreditsAndAwardsData from "./credits-and-awards-data/credits-and-awards-data";

export { RadioDefault } from "./radio-default/radio-default";
export { ThumbUpload } from "./thumb-upload/thumb-upload";
export { TitleAndSynopsisData } from "./title-and-synopsis-data/title-and-synopsis-data";
export { CreditsAndAwardsData }
export { LanguageAndSubtitlesData } from "./language-and-subtitles-data/language-and-subtitles-data";
export { AudioAndMusicData } from "./audio-and-music-data/audio-and-music-data";
export { DetailsData } from "./details-data/details-data";